import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'fc-hint',
  template: `<ng-content />`,
  styles: `
    @use 'var' as *;

    :host {
      margin-top: 4px;
      flex: 1;
      color: $secondary-400;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;

      &.fc-hint--start {
        align-self: flex-start;
      }

      &.fc-hint--end {
        align-self: flex-end;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.fc-hint--start]': 'align() === "start"',
    '[class.fc-hint--end]': 'align() === "end"',
  },
})
export class HintComponent {
  align = input<'start' | 'end'>();
}
